/*
base controller
*/

export default class Controller {
  constructor(options) {
    Object.assign(this, options);
    var {_mainView} = this.app;
    this.viewPort = _mainView;
    this._currentRoute = '';
  }

  ///end of action methods
  //////////////////////


  ///private functions
  navigateTo(url) {
    if(typeof this._router === 'undefined')
      this._router = this.app.router;
    this._router.navigate(url, {replace: true});
  }


  get currentRoute() {
    return this._currentRoute;
  }

}



// WEBPACK FOOTER //
// src/js/controller/base.js